'use client';
import { Spacer } from '@/shared/components/parts/Spacer';
import { PaginationButton } from './PaginationButton';
import { TitleCard } from './TitleCard';
import { usePurchasedList } from './index.hook';

export const PurchasedList: React.FC = () => {
  const { state } = usePurchasedList();

  return (
    <div>
      {state.pageStatus === 'INIT' && (
        <div className="tw-text-base2 tw-text-main-60">読込中...</div>
      )}
      {state.pageStatus === 'PREPARED' && (
        <div>
          {state.userList.length > 0 ? (
            <div className="tw-grid tw-grid-cols-2 tw-gap-[1rem] tablet:tw-grid-cols-5">
              {state.userList.map((wabikenMeta) => (
                <TitleCard key={wabikenMeta.id} wabikenMeta={wabikenMeta} />
              ))}
            </div>
          ) : (
            <div className="tw-py-[4rem] tw-text-base1 tw-font-bold tw-text-main-40">
              作品がありません。
            </div>
          )}
          <Spacer level={2} />
          <div className="tw-flex tw-items-center tw-justify-center tw-gap-[1rem]">
            <div className="tw-w-[6rem]">
              {state.hasPrev && <PaginationButton type="prev" />}
            </div>
            <div className="tw-truncate tw-text-center tw-text-base2 tw-font-bold tw-text-brand-lv1">
              {state.userList.length > 0 &&
                `${state.currentPageNo} / ${state.totalPage}`}
            </div>
            <div className="tw-w-[6rem]">
              {state.hasNext && <PaginationButton type="next" />}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
